import React, {useState} from 'react';

const CommandsContext = React.createContext({
  commands: undefined,
});

export const CommandsContextProvider = ({children}) => {
  const [commands, setCommands] = useState({});

  return (
    <CommandsContext.Provider value={{commands, onUpdateCommands: setCommands}}>
      {children}
    </CommandsContext.Provider>
  );
};
export default CommandsContext;
